import { getSyntheticsResultId, getSyntheticsTestId, willSyntheticsInjectRum } from '@datadog/browser-core'

export function getSyntheticsContext() {
  const testId = getSyntheticsTestId()
  const resultId = getSyntheticsResultId()

  if (testId && resultId) {
    return {
      test_id: testId,
      result_id: resultId,
      injected: willSyntheticsInjectRum(),
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-rum-core/src/domain/contexts/syntheticsContext.ts